export const PHOTO_LIMIT = 6;
export const FIRST_FILTERED_YEAR = 2022;
